import { render, staticRenderFns } from "./FriendApply.vue?vue&type=template&id=08e59cbb"
import script from "./FriendApply.vue?vue&type=script&lang=js"
export * from "./FriendApply.vue?vue&type=script&lang=js"
import style0 from "./FriendApply.vue?vue&type=style&index=0&id=08e59cbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports